import { z } from "zod";
import {
  ReceivableCurrency,
  ReceivableTax,
  ReceivableTaxType,
  PendingReceivableTax,
  ReceivableTaxDocumentType,
} from "../../../utils/types";

export const taxFormSchema = z.object({
  currency: z.nativeEnum(ReceivableCurrency, { required_error: "Selecione a moeda" }),
  type: z.nativeEnum(ReceivableTaxType, { required_error: "Selecione o tipo da taxa" }),
  description: z.string().max(255, "Máximo de 255 caracteres").optional(),
  document: z.string().url("Informe uma URL válida").optional().or(z.literal("")),
  value: z
    .number({ invalid_type_error: "Informe um valor numérico" })
    .positive("Valor deve ser positivo"),
});

export type TaxFormValues = z.infer<typeof taxFormSchema>;

export type TaxListItem =
  | { kind: "existing"; tax: ReceivableTax }
  | { kind: "pending"; tax: PendingReceivableTax };

export type DocumentDraft = {
  documentType: ReceivableTaxDocumentType | "";
  description: string;
  file?: File;
};

export const createEmptyDocumentDraft = (): DocumentDraft => ({
  documentType: "",
  description: "",
  file: undefined,
});

